/**
 * Format a number to REAL.
 */
export const format = number => number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/**
 * Create array with callback.
 */
export const createArray = (length, callback = (_, index) => index) => Array(length).fill(0).map(callback);

/**
 * Create array with random values to use in charts.
 */
export const createChartArray = async (base, length, interval, divisor = 1000) => {
  const max = base / divisor;
  const now = Date.now();

  const prices = [
    [
      now,
      (base / 100),
    ],
  ];

  for (let i = 0; i < length; i++) {
    const [
      last_timestamp,
      last_price,
    ] = prices[i];
    const price = (Math.random() * max);
    const possible = last_price + (Math.random() > .5 ? 1 : -1) * price;

    prices.push(
      [
        last_timestamp - interval,
        possible > 0
          ? possible
          : last_price + price,
      ]
    );
  }

  return prices;
};

/**
 * Handle outside click.
 */
export const useOutsideClick = (instance, ref, callback) => {
  const handler = (event) => {
    if (instance.$refs[ref] == event.target || instance.$refs[ref].contains(event.target)) {
      return;
    }

    callback();
  };

  document.body.addEventListener('click', handler, true);

  instance.$once('hook:destroyed', () => document.body.removeEventListener('click', handler, true));
};
